import { onMounted, onBeforeUnmount } from "vue";
const useCaptureEvent = (event, cb, options = {}) => {
  onMounted(() => window.addEventListener(event, cb, { capture: true, ...options }));
  onBeforeUnmount(() => window.removeEventListener(event, cb, { capture: true, ...options }));
};
export {
  useCaptureEvent as u
};
//# sourceMappingURL=useCaptureEvent.js.map
